import { ToastController } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { AppSettings } from './app-settings'

@Injectable()
export class ToastService {

    constructor(private toastCtrl: ToastController) {}

    presentToast(message: string) {
        let toast = this.toastCtrl.create({
            message: message,
            duration: 3000,
            position: 'bottom',
            cssClass: 'toast-container interactive-toast',
            showCloseButton: true,
            closeButtonText: '✕',
            dismissOnPageChange: true
        });
        toast.present();
    }
}


// WEBPACK FOOTER //
// ./src/services/toast-service.ts